module.exports = __webpack_public_path__ + "static/media/MTA-Introduction_to_Programming_Using_JavaScript.e8b59199.png";